import classNames from 'classnames'
import { Token } from 'symbiosis-js-sdk'

import Asset from '~/components/Asset'
import { useGetOriginLikeToken } from '~/hooks/useGetOriginLikeToken'

import styles from './Tokens.pcss'

interface Props {
	className?: string
	token: Token
}

function Tokens({ className, token }: Props) {
	const originLikeToken = useGetOriginLikeToken(token)

	return (
		<div className={classNames(styles.container, className)}>
			<div className={styles.assetContainer}>
				<Asset token={originLikeToken} minimal />
			</div>
		</div>
	)
}

export default Tokens
